import React from "react";
import StepsEditor from "./StepsEditor";
import Button from "../../../../../../components/elements/Button";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faTrash} from "@fortawesome/free-solid-svg-icons";
import InputField from "../../../../../../components/elements/InputField";

export default function PartCard({part, path, updateAtPath, onDelete, canDelete}) {
    const updateName = (name) => updateAtPath([...path, "name"], name);

    return (
        <div
            className='border-2 border-gray-300 mt-5 rounded-md p-8 d-grid gap-5'>
            <div className='flex items-center justify-between mb-10'>
                <InputField
                    title={'تیتر بخش'}
                    value={part.name || ""}
                    onChange={(e) => updateName(e.target.value)}
                />

                <Button type="button" onClick={onDelete} disabled={!canDelete}>
                    <FontAwesomeIcon icon={faTrash} size={'xl'}/>
                </Button>
            </div>

            <StepsEditor
                steps={part.steps || []}
                path={[...path, "steps"]}
                updateAtPath={updateAtPath}
            />
        </div>
    );
}
